
import SimpleMap from '../../components/SimpleMap/SimpleMap';
import MapContainer from "../../components/MapContainer";
import SearchBar from "../../components/SearchBar/SearchBar";
import MarkerMap from "../../components/MarkerMap";



function MapTester() {
    return (
        <div>
            <MarkerMap />
            {/* one */}
            {/* <MapContainer />
            <br />
            <SearchBar /> */}

            {/* two */}
            {/* <SimpleMap />
            <MapForm /> */}
        </div >
    )
}

export default MapTester;
